import styled from "styled-components";

export const PaymentFormContainer = styled.div`
  height: 250px;
  width: 200px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: 1px solid rgb(227, 223, 223);
  border-radius: 4px;
  padding-bottom: 20px;
  margin-top: 15px;
  min-width: 500px;
`;
